module.exports = "https://s91588.cdn.ngenix.net/creditselection-frontend/_next/static/images/card3-ab3b4dd2f3fc35dc4121309c1e4cd34c.png";